




































import {Component, Mixins, Vue} from "vue-property-decorator";
import CategoryManager from "./../components/CategoryManager.vue";
import ProjectManager from "./../components/ProjectManager.vue";
import TestimonialManager from "./../components/TestimonialManager.vue";
import ContactFormManager from "./../components/ContactFormManager.vue";
import SiteMetrics from "../components/SiteMetrics.vue";
import ServiceManager from "./../components/ServiceManager.vue";
import UserFileManager from "./../components/UserFileManager.vue";
import TrackedLinkManager from "./../components/TrackedLinkManager.vue";
import AuthMixin from "../mixins/AuthMixin";
import ClientsList from "./../components/clients/List.vue";
import Accounting from "./../components/Accounting.vue"

@Component({
    name: "Admin", 
    components: {
        CategoryManager, 
        ProjectManager, 
        TestimonialManager, 
        ContactFormManager,
        SiteMetrics,
        ServiceManager,
        UserFileManager,
        TrackedLinkManager,
        ClientsList,
        Accounting,
    }
})
export default class Admin extends Mixins(AuthMixin) {
    private async created() {
        await this.authorizeFor('ADMIN');
    }
}
